var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_579_590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26706 17.7833C0.918658 17.7833 0.620342 17.6527 0.372117 17.3914C0.124039 17.1303 0 16.8164 0 16.4496H3.13432C2.77865 16.4496 2.46744 16.3162 2.20069 16.0494C1.93394 15.7827 1.80056 15.4715 1.80056 15.1158V4.00123C1.80056 3.64556 1.93394 3.33436 2.20069 3.06761C2.46744 2.80086 2.77865 2.66748 3.13432 2.66748H18.2057C18.5614 2.66748 18.8726 2.80086 19.1393 3.06761C19.4061 3.33436 19.5395 3.64556 19.5395 4.00123V15.1158C19.5395 15.4715 19.4061 15.7827 19.1393 16.0494C18.8726 16.3162 18.5614 16.4496 18.2057 16.4496H21.34C21.34 16.8201 21.2095 17.135 20.9483 17.3943C20.6871 17.6537 20.3731 17.7833 20.0063 17.7833H1.26706ZM11.2035 17.072C11.3517 16.9238 11.4258 16.746 11.4258 16.5385C11.4258 16.331 11.3517 16.1532 11.2035 16.005C11.0553 15.8568 10.8775 15.7827 10.67 15.7827C10.4625 15.7827 10.2847 15.8568 10.1365 16.005C9.98831 16.1532 9.91422 16.331 9.91422 16.5385C9.91422 16.746 9.98831 16.9238 10.1365 17.072C10.2847 17.2202 10.4625 17.2943 10.67 17.2943C10.8775 17.2943 11.0553 17.2202 11.2035 17.072ZM3.13432 15.1158H18.2057V4.00123H3.13432V15.1158Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_579_590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.34,
    height: 21.34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopIcon);
export default __webpack_public_path__ + "static/media/laptop_icon.ae7a6d5427293d66cb7aba806bf460ca.svg";
export { ForwardRef as ReactComponent };